













































































































































import Spinner from "@/components/Common/Spinner.vue";
import { Vue, Component, Prop } from "vue-property-decorator";
import { httpStore, customizationStore, onboardingStore } from "@/store/typed";
import DebugWindow from "@/components/Debug.vue";
import { ProductCustomizationMixinTags } from "@/mixins/http/ProductCustomizationMixin";
import { SHOW_DEBUG_TOOLS } from "@/constants";
import { showSuccess, showError } from "@/helpers/Toast";
import { Tags } from "@/helpers/CanvasManager";
import { isMobile } from "@/helpers/mediaQueryHelper";

@Component({ components: { Spinner, DebugWindow } })
export default class Controls extends Vue {
  @Prop({ default: false }) readonly disabled!: boolean;
  @Prop({ default: false }) readonly rollbacking!: boolean;

  private debug = false;
  private sideMenuOpen = false;

  emit(action: string) {
    if (this.disabled) {
      return;
    }
    this.$emit(action);
  }

  get showDebugButton() {
    return SHOW_DEBUG_TOOLS;
  }
  get rgbColorProfile() {
    return this.printAreaCustomization.colorProfile != "greyscale";
  }

  get isMobile() {
    return isMobile((this as any).$mq);
  }

  emitRollback() {
    if (this.canRollback && !this.rollbacking) {
      this.$emit("rollback");
    }
  }

  get zoomEnabled() {
    return customizationStore.zoomEnabled;
  }

  openOnBoarding(){
    this.sideMenuOpen=false;
    onboardingStore.setOnboarding(true);
  }

  onZoomChanged() {
    if (this.disabled) {
      return;
    }
    customizationStore.setZoomEnabled(!this.zoomEnabled);
  }

  get uploading(): boolean {
    return httpStore.status[ProductCustomizationMixinTags.Upload]?.loading;
  }

  get uploadingEmoji(): boolean {
    return httpStore.status[Tags.LoadEmoji]?.loading;
  }

  get printAreaCustomization() {
    return customizationStore?.currentPrintAreaCustomization;
  }

  get canRollback() {
    return this.outputHistoryLength > 1;
  }

  get outputHistoryLength() {
    return this.printAreaCustomization?.outputHistory?.length || 0;
  }

  get outputHistoryObjects() {
    return this.printAreaCustomization?.output?.objects.length || 0;
  }

  onSideMenuClicked() {
    if (this.disabled) {
      return;
    }
    this.sideMenuOpen = !this.sideMenuOpen;
  }

  emitImageAdd() {
    if (!this.uploading) {
      this.emit("add-image");
    }
  }

  back() {
    this.$emit("back");
  }
}
